'use client';

import { Breadcrumb } from 'flowbite-react';

type Props = {
    parentPage?: string;
    currentPage: string;
    isParent?: boolean;
};
const DefaultBreadcrumb: React.FC<Props> = ({ parentPage, currentPage, isParent }) => {
    return (
        <section className="bg-grey border-b border-t">
            <div className="container lg:container mx-auto">
                <Breadcrumb aria-label="Default breadcrumb example" className="breadcumb-pages">
                    <Breadcrumb.Item className="text-secondary" href="/">
                        Home
                    </Breadcrumb.Item>
                    {isParent ? <Breadcrumb.Item>{parentPage}</Breadcrumb.Item> : <></>}
                    <Breadcrumb.Item>{currentPage}</Breadcrumb.Item>
                </Breadcrumb>
            </div>
        </section>
    );
};

export default DefaultBreadcrumb;
